<app-dialog
	modalTitle="Selecionar benefício {{
		data.type === 'dental'
			? 'dental'
			: data.type === 'health'
				? 'de saúde'
				: 'conjugado'
	}}"
	[hideFooter]="true"
	(dialogClose)="closeModal()"
>
	<ul class="mb-fix">
		<li>
			<div
				class="d-f fd-c jc-c mb-xxxs ml-xxs mr-xxs p-xxxs br-md c-p item"
				(click)="dialogRef.close(null)"
			>
				<span class="fs-xxs lh-xs">Nenhum plano</span>
			</div>
		</li>
		<li *ngFor="let benefit of data.benefits">
			<div
				class="d-f fd-c jc-c mb-xxxs ml-xxs mr-xxs p-xxxs br-md c-p item"
				(click)="dialogRef.close(benefit)"
			>
				<span class="fs-xxxs fw-bold lh-xs gray">Plano</span>
				<span class="mt-quark fs-xxs lh-xs to-ellipsis">
					{{ benefit.name }}
				</span>
			</div>
		</li>
	</ul>
</app-dialog>
